import { render, staticRenderFns } from "./CieloLayout.vue?vue&type=template&id=0c9d8a49&scoped=true"
import script from "./CieloLayout.vue?vue&type=script&lang=js"
export * from "./CieloLayout.vue?vue&type=script&lang=js"
import style0 from "./CieloLayout.vue?vue&type=style&index=0&id=0c9d8a49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9d8a49",
  null
  
)

export default component.exports